export class FeatureToBeRenamed {
  public constructor(
    public FeatureName: string,
    public NewName: string)
  {
  }
}
